import {
  GetListParams,
  GetListResult,
  GetOneParams,
  GetOneResult,
  RaRecord,
} from "react-admin";
import { getJson } from "../../../utils/api";
import IHandler from "./IHandler";

import { LogRecord } from "../../../models";
import {
  expandTraceWithLogs,
  extractAnalyticsCalls,
  extractChatPrompt,
  extractNotification,
  flattenTrace,
} from "../../../utils/trace-util";

export default class LogsHandler implements IHandler {
  static route = "/admin/profiles";
  static resourceIdName = "user_id";

  static async getListHandler(
    resource?: string,
    params?: GetListParams
  ): Promise<GetListResult<LogRecord>> {
    const page = params?.pagination.page ?? 1;

    const query: { [key: string]: any } = {
      // fetch_details: false,
      limit: params?.pagination.perPage ?? 100,
      page,
      ...params?.filter,
    };

    return getJson(`${resource}?${new URLSearchParams(query).toString()}`).then(
      async (response) => {
        const { logs, main_trace } = await response.json();

        if (!main_trace) {
          return {
            data: [],
            pageInfo: {
              hasNextPage: false,
              hasPrevPage: false,
            },
          };
        }

        const trace = expandTraceWithLogs(flattenTrace(main_trace), logs || []);
        // console.log(JSON.stringify(logs));
        // console.log(JSON.stringify(trace));
        // console.log(JSON.stringify(main_trace));

        const ret: LogRecord[] = [];
        ret.push({
          id: "Trace ID",
          value: main_trace.trace_id,
          timestamp: 0,
        });

        const prompt = extractChatPrompt(trace) ?? [];

        prompt.forEach(({ input, output, timestamp, name }) => {
          if (input) {
            ret.push({
              timestamp,
              id: `${name} Inputs`,
              value: JSON.stringify(input, null, 2),
            });
          }

          if (output) {
            ret.push({
              timestamp,
              id: `${name} Outputs`,
              value: output.join("\n"),
            });
          }
        });

        const analyticsCalls = extractAnalyticsCalls(trace);
        analyticsCalls.forEach(
          ({ name, input, output, timestamp, toolName }) => {
            if (input) {
              ret.push({
                timestamp,
                id: `${name} Inputs`,
                value:
                  toolName === "python_repl_ast"
                    ? input
                    : JSON.stringify(input, null, 2),
              });
            }

            if (output) {
              ret.push({
                timestamp,
                id: `${name} Outputs`,
                value:
                  toolName === "python_repl_ast"
                    ? output
                    : JSON.stringify(output, null, 2),
              });
            }
          }
        );

        const { input: notification, timestamp } = extractNotification(trace);
        if (notification) {
          ret.push({
            timestamp: timestamp ?? 1000000000,
            id: `Notification`,
            value: JSON.stringify(notification, null, 2),
          });
        }

        return {
          data: ret
            .map((row) => ({
              ...row,
              valueTrimmed:
                row.value.length > 500
                  ? row.value.substring(0, 500) + "..."
                  : row.value,
            }))
            .sort((a, b) => a.timestamp - b.timestamp),
          pageInfo: {
            hasNextPage: true,
            hasPrevPage: page > 1,
          },
        };
      }
    );
  }

  static async getOneHandler<RecordType extends RaRecord = any>(
    resource: string,
    params?: GetOneParams<any>
  ): Promise<GetOneResult<RecordType>> {
    const id = params?.id;
    return getJson(`${this.route}/${id}`).then(async (response) => {
      const { data } = await response.json();

      data.id = data[this.resourceIdName];
      delete data[this.resourceIdName];

      return {
        data: {
          ...data,
        },
      };
    });
  }
}
